import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dskhome-footer-logo-address',
  templateUrl: './footer-logo-address.component.html',
  styleUrls: ['./footer-logo-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLogoAddressComponent {}
